define('views/modules/setting/business/business-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    // services
    'services/i18n',
    'services/user',
    'services/api',
    // Views
    'views/modules/setting/business/blocks/payment/payment-list',
    'views/modules/setting/business/blocks/brand/brand',
    'views/modules/setting/business/blocks/custom-data/custom-data',
    'views/modules/setting/business/blocks/custom-exercises/custom-exercises',
    'views/modules/setting/business/blocks/custom-tags/custom-tags',
    'views/modules/setting/business/blocks/custom-exercise-names',
    'views/modules/setting/business/blocks/custom-button/custom-button',
    'views/modules/setting/business/modals/payment-modify-plan-modal',
    'views/modules/setting/business/modals/payment-add-method-modal',
    'views/modules/setting/business/modals/payment-update-method-modal',
    'views/modules/setting/business/modals/payment-delete-method-modal',
    'views/modules/setting/business/modals/payment-invoice-history-modal',
    'views/modules/profile/blocks/custom-messages',
    'views/modules/profile/blocks/preferences-business',
    // models & collections
    'collections/payment/team-payments',
    'collections/payment/membership-plans',
    // Templates Blocks
    'text!templates/modules/setting/business/business-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    // services
    i18n,
    User,
    API,
    // Views
    VPaymentList,
    VBlockBrand,
    VBlockCustomData,
    VBlockCustomExercises,
    VBlockCustomTags,
    VBlockCustomExerciseNames,
    VBlockCustomButton,
    VPaymentModifyPlanModal,
    VPaymentAddMethodModal,
    VPaymentUpdateMethodModal,
    VPaymentDeleteMethodModal,
    VPaymentInvoiceHistoryModal,
    VBlockCustomMessages,
    VBlockPreferencesBusiness,
    // models & collections
    CTeamPayments,
    CMembershipPlans,
    // Template
    TBusinessSetting
) {

    var VBusinessSetting = Backbone.View.extend({
        template: TBusinessSetting,
        regions: {
            paymentList: "#setting-payments",
            brand: "#setting-brand",
            customData: "#setting-custom-data",
            customExercises: "#setting-custom-exercises",
            customTags: "#setting-custom-tags",
            customExerciseNames: "#setting-custom-exercise-names",
            customButton: "#setting-custom-button",
            customMessages: "#setting-custom-messages",
            preferences: "#setting-preferences",
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                group: opt.group
            });

            this.initPaymentList();

            var model = this.model,
                view = this.view = {
                    brand: new VBlockBrand({
                        model: model,
                        group: this.group
                    }),
                    customData: new VBlockCustomData({
                        model: model, // profile
                    }),
                    customExercises: new VBlockCustomExercises({
                        model: model, // profile
                        url: this.url,
                        group: this.group
                    }),
                    customTags: new VBlockCustomTags({
                        model: model, // profile
                        group: this.group
                    }),
                    //Hidden on 23/04/2018, see bug V6 for more details
                    // customExerciseNames: new VBlockCustomExerciseNames({
                    //     model: model, // profile
                    //     group: this.group
                    // }),
                    customButton: new VBlockCustomButton({
                        model: model,
                        group: this.group
                    }),
                    customMessages: new VBlockCustomMessages({ model: model }),
                    preferences: new VBlockPreferencesBusiness({
                        model: model,
                        group: opt.group
                    })
                };

            var viewCallbacks = { 'panel:stack': this.onStack };
            this.listenTo(view.brand, viewCallbacks)
                .listenTo(view.customData, viewCallbacks)
                .listenTo(view.customExercises, viewCallbacks)
                .listenTo(view.customTags, viewCallbacks)
                .listenTo(view.customButton, viewCallbacks)
                .listenTo(view.customMessages, viewCallbacks)
                .listenTo(view.preferences, viewCallbacks);
                //.listenTo(view.customExerciseNames, viewCallbacks);
        },

        initPaymentList: function() {
            var teamPaymentsCollection = this.teamPaymentsCollection = new CTeamPayments();
            teamPaymentsCollection.fetch({
                context: this,
                success: this.renderPaymentList
            });

            var membershipPlansCollection = this.membershipPlansCollection = new CMembershipPlans();
            membershipPlansCollection.fetch({
                context: this,
                success: this.renderPaymentList
            });

            this.listenTo(teamPaymentsCollection, { "payment:modify-plan": this.onPaymentModifyPlan })
                .listenTo(teamPaymentsCollection, { "payment:add-method": this.onPaymentAddMethod })
                .listenTo(teamPaymentsCollection, { "payment:update-method": this.onPaymentUpdateMethod })
                .listenTo(teamPaymentsCollection, { "payment:delete-method": this.onConfirmDeleteMethod })
                .listenTo(teamPaymentsCollection, { "payment:show-invoice-history": this.onShowInvoiceHistory });
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();

            var view = this.view,
                zone = this.zone;

            this.assign(view.customData, zone.$customData)
                .assign(view.customButton, zone.$customButton)
                .assign(view.customExercises, zone.$customExercises)
                .assign(view.customMessages, zone.$customMessages)
                .assign(view.preferences, zone.$preferences);
                //.assign(view.customExerciseNames, zone.$customExerciseNames);
                //.assign(view.customTags, zone.$customTags)

            if (User.getMainGroup().isOwner) {
                this.assign(view.brand, zone.$brand);
            }

            this.renderPaymentList();

            return this;
        },

        renderPaymentList: function() {
            if (this.teamPaymentsCollection.length !== 0 && this.membershipPlansCollection.length !== 0) {
                this.view.paymentList = new VPaymentList({
                    collection: this.teamPaymentsCollection,
                    membershipPlans: this.membershipPlansCollection,
                });
                this.assign(this.view.paymentList, this.zone.$paymentList);
            }
        },

        onStack: function(view) {
            this.trigger('panel:stack', view);
        },

        onPaymentModifyPlan: function(teamPaymentModel) {
            var view = this.view.modifyPlan;

            if (view) {
                view.updateOptions({ teamPaymentModel: teamPaymentModel });
            } else {
                view = this.view.modifyPlan = new VPaymentModifyPlanModal({
                    group: this.group,
                    profile: this.profile,
                    context: this,
                    callback: this.onModelChange,
                    planList: this.membershipPlansCollection,
                    teamPaymentModel: teamPaymentModel
                });
            }

            view.show();
        },

        onPaymentAddMethod: function(teamPaymentModel, listView, options) {
            var currentPlanModel = this.membershipPlansCollection.findWhere({ name: teamPaymentModel.getMembershipPlan() });
            var pendingPlanModel = null;

            var view = this.view.addMethod;

            if (view) {
                view.updateOptions({
                    currentPlanModel: currentPlanModel,
                    teamPaymentModel: teamPaymentModel
                });
            } else {
                view = this.view.addMethod = new VPaymentAddMethodModal({
                    group: this.group,
                    profile: this.profile,
                    context: this,
                    callback: this.onModelChange,
                    currentPlanModel: currentPlanModel,
                    teamPaymentModel: teamPaymentModel,
                    listView: listView
                });
            }

            view.show();
        },

        onPaymentUpdateMethod: function(teamPaymentModel, listView, options) {
            var currentPlanModel = this.membershipPlansCollection.findWhere({ name: teamPaymentModel.getMembershipPlan() });
            var pendingPlanModel = null;

            if (options && options.pendingMembership) {
                pendingPlanModel = this.membershipPlansCollection.findWhere({ name: options.pendingMembership });
            }

            var view = this.view.updateMethod;

            if (view) {
                view.updateOptions({
                    currentPlanModel: currentPlanModel,
                    teamPaymentModel: teamPaymentModel,
                    pendingPlanModel: pendingPlanModel,
                });
            } else {
                view = this.view.updateMethod = new VPaymentUpdateMethodModal({
                    group: this.group,
                    profile: this.profile,
                    context: this,
                    callback: this.onModelChange,
                    currentPlanModel: currentPlanModel,
                    teamPaymentModel: teamPaymentModel,
                    listView: listView,
                    pendingPlanModel: pendingPlanModel,
                });
            }

            view.show();
        },

        onConfirmDeleteMethod: function(teamPaymentModel, listView) {
            this.deleteOptions = {
                context: this,
                teamPaymentModel: teamPaymentModel,
                listView: listView
            };

            Bootbox.confirm({
                title: i18n.t('payment:deleting_payment_method_confirm_title'),
                message: i18n.t('payment:deleting_payment_method_confirm_message'),
                callback: this.onPaymentDeleteMethod,
                context: this,
            });
        },

        onPaymentDeleteMethod: function(result) {
            if (result) {
                var view = this.view.deleteMethod;

                if (!view) {
                    view = this.view.deleteMethod = new VPaymentDeleteMethodModal(this.deleteOptions);
                }

                view.show();
            }
        },

        onShowInvoiceHistory: function(teamPaymentModel, listView) {
            var view = this.view.invoiceHistory;

            if (!view) {
                view = this.view.invoiceHistory = new VPaymentInvoiceHistoryModal(teamPaymentModel);
            }

            view.show();
        },

    });

    return VBusinessSetting;
});

